import {
  notificationsSettings,
  UserProfileResponce,
  UserProfileSocket,
} from ".";
import { authNoTokenDTO } from "../auth";
import { RoleType } from "../users";
import {
  IChangeLanguage,
  IChangeLanguageFailure,
  IChangeLanguageSuccess,
  IChangeNotification,
  IChangeNotificationFailure,
  IChangeNotificationSockets,
  IChangeNotificationSuccess,
  IDeleteUserAvatarFailure,
  IDeleteUserAvatarRequest,
  IDeleteUserAvatarSuccess,
  IEditUserAvatarFailure,
  IEditUserAvatarRequest,
  IEditUserAvatarSuccess,
  IEditUserProfileRequest,
  IEditUserProfileSuccess,
  IGetUserProfileBySocket,
  ISetDataFromAuth,
  ISetUserProfileIdFromToken,
  ISetUserProfileRoleFromToken,
  IUserProfileChangeMonitorNodeAction,
  IUserProfileChangeSelectedENDNodeAction,
  IUserProfileChangeSelectedNdeAction,
  IUserProfileDeleteNodeActionBySockets,
  USER_PROFILE,
  UserProfileActionTypes,
} from "./types";

export function userProfileRequest(
  withErrorMessage?: boolean
): UserProfileActionTypes {
  return {
    type: USER_PROFILE.REQUEST,
    payload: { withErrorMessage: withErrorMessage ? withErrorMessage : false },
  };
}
export function userProfileSuccess(
  value: UserProfileResponce
): UserProfileActionTypes {
  return { type: USER_PROFILE.SUCCESS, payload: value };
}
export function userProfileFailure(value: any): UserProfileActionTypes {
  return { type: USER_PROFILE.FAILURE, payload: value };
}

export function userProfileForCheckTokenRequest(): UserProfileActionTypes {
  return { type: USER_PROFILE.REQUEST_FOR_CHECK_TOKEN, payload: undefined };
}
export function userProfileForCheckTokenSuccess(
  value: UserProfileResponce
): UserProfileActionTypes {
  return { type: USER_PROFILE.SUCCESS_FOR_CHECK_TOKEN, payload: value };
}
export function userProfileForCheckTokenFailure(
  value: any
): UserProfileActionTypes {
  return { type: USER_PROFILE.FAILURE_FOR_CHECK_TOKEN, payload: value };
}

export function userProfileChangeSelectedNodeId(
  value: number
): IUserProfileChangeSelectedNdeAction {
  return { type: USER_PROFILE.CHANGE_SELECTED_NODE_ID, payload: value };
}

export function userProfileChangeSelectedEndNodeId(
  value: number
): IUserProfileChangeSelectedENDNodeAction {
  return { type: USER_PROFILE.CHANGE_SELECTED_END_NODE_ID, payload: value };
}

export function userProfileChangeMonitorNodeId(
  value: number
): IUserProfileChangeMonitorNodeAction {
  return { type: USER_PROFILE.CHANGE_MONITOR_NODE_ID, payload: value };
}

//POST /api/v2/users/avatar
export function editUserAvatar(value: File): IEditUserAvatarRequest {
  return { type: USER_PROFILE.EDIT_AVATAR_REQUEST, payload: value };
}
export function editUserAvatarSuccses(value: string): IEditUserAvatarSuccess {
  return { type: USER_PROFILE.EDIT_AVATAR_SUSSESS, payload: value };
}
export function editUserAvatarFailure(value: any): IEditUserAvatarFailure {
  return { type: USER_PROFILE.EDIT_AVATAR_FAILURE, payload: value };
}

export function getUserProfileBySocket(
  value: UserProfileSocket
): IGetUserProfileBySocket {
  return { type: USER_PROFILE.GET_PROFILE_BY_SOCKET, payload: value };
}

export function editUserProfile(value: {
  firstName: string;
  lastName: string;
}): IEditUserProfileRequest {
  return { type: USER_PROFILE.EDIT_PROFILE_REQUEST, payload: value };
}
export function editUserProfileSuccses(value: string): IEditUserProfileSuccess {
  return { type: USER_PROFILE.EDIT_PROFILE_SUSSESS, payload: value };
}
export function editUserProfileFailure(value: any): IEditUserAvatarFailure {
  return { type: USER_PROFILE.EDIT_PROFILE_FAILURE, payload: value };
}

export function deleteUserAvatar(): IDeleteUserAvatarRequest {
  return { type: USER_PROFILE.DELETE_USER_AVATAR, payload: undefined };
}
export function deleteUserAvatarSuccses(value: any): IDeleteUserAvatarSuccess {
  return { type: USER_PROFILE.DELETE_USER_AVATAR_SUSSESS, payload: value };
}
export function deleteUserAvatarFailure(value: any): IDeleteUserAvatarFailure {
  return { type: USER_PROFILE.DELETE_USER_AVATAR_FAILURE, payload: value };
}

export function deleteNodeBySockets(
  value: number[]
): IUserProfileDeleteNodeActionBySockets {
  return { type: USER_PROFILE.DELETE_NODE_BY_SOCKETS, payload: value };
}

export function changeUserLanguage(
  lang: string,
  withPreload = true
): IChangeLanguage {
  return {
    type: USER_PROFILE.CHANGE_LANGUAGE,
    payload: { language: lang, withPreload },
  };
}
export function changeUserLanguageSuccses(
  payload: string
): IChangeLanguageSuccess {
  return { type: USER_PROFILE.CHANGE_LANGUAGE_SUSSESS, payload };
}
export function changeUserLanguageFailure(
  payload: any
): IChangeLanguageFailure {
  return { type: USER_PROFILE.CHANGE_LANGUAGE_FAILURE, payload };
}

export function changeUserNotification(
  userId: string,
  value: notificationsSettings
): IChangeNotification {
  return { type: USER_PROFILE.CHANGE_NOTIFICATION, payload: { userId, value } };
}
export function changeUserNotificationSuccses(
  payload: notificationsSettings
): IChangeNotificationSuccess {
  return { type: USER_PROFILE.CHANGE_NOTIFICATION_SUSSESS, payload };
}
export function changeUserNotificationFailure(
  payload: any
): IChangeNotificationFailure {
  return { type: USER_PROFILE.CHANGE_NOTIFICATION_FAILURE, payload };
}

export function changeUserNotificationSockets(
  userId: string,
  value: notificationsSettings
): IChangeNotificationSockets {
  return {
    type: USER_PROFILE.CHANGE_NOTIFICATION_BY_SOCKETS,
    payload: { userId, value },
  };
}
//deprecated
export function setUserIdFromToken(userId: string): ISetUserProfileIdFromToken {
  return { type: USER_PROFILE.SET_USER_ID, payload: userId };
}
export function setUserRoleFromToken(
  role: RoleType
): ISetUserProfileRoleFromToken {
  return { type: USER_PROFILE.SET_USER_ROLE, payload: role };
}

export function setUserDataFromAuth(auth: authNoTokenDTO): ISetDataFromAuth {
  return { type: USER_PROFILE.SET_USER_DATA_FROM_AUTH, payload: auth };
}
